import React from 'react'
import Link from 'gatsby-link'
import Logo from '../ww-logo'
import Bus from '../../utils/bus'
import ClassNames from 'classnames'
import NavMenu from './nav-menu'
import CartButton from '../cart/cart-open'

let BUS = new Bus()

class NavOpen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
    this.close = this.close.bind(this)
    this.open = this.open.bind(this)
  }

  componentDidMount() {
    BUS.listen('OPEN_NAV', this.open)
    BUS.listen('OPEN_CART', this.close)
    BUS.listen('CLOSE_MENU', this.close)
  }

  open() {
    this.setState({
      open: true,
    })
  }

  close(event) {
    this.setState({
      open: false,
    })
  }

  render() {
    return (
      <div
        className={ClassNames({
          NavOpen: true,
          'is-actually-open-tho': this.state.open,
        })}
      >
        <div className="bg" onClick={this.close} />
        <div className="items">
          <NavMenu location={this.props.location} />
        </div>
        <button className="close nav" onClick={this.close}>
          <span>&times;</span>
        </button>
      </div>
    )
  }
}

export default NavOpen



// WEBPACK FOOTER //
// ./src/components/nav/nav-open.js